<template>
  <div class="flex flex-col items-center justify-center">
    <graphic-base width="110" height="110" view-box="0 0 100 100">
      <circle-check />
    </graphic-base>
    <div
      class="text-center my-12 text-center"
      :style="[passwordExpiredCustomParamsFields.styles.form.textColor]"
    >
      <h1 class="success-message text-zt-xl mb-4">
        {{
          $t('message.loginComponent.passwordExpired.success.success_message')
        }}
      </h1>
      <div
        class="text-zt-dark-400 w-2/3 lg:w-6/12 mx-auto mb-2"
        :style="[passwordExpiredCustomParamsFields.styles.form.textColor]"
      >
        <p>
          {{ $t('message.loginComponent.passwordExpired.success.pls_go_back') }}
        </p>
      </div>
    </div>
    <div class="mb-4 w-full">
      <zt-button
        class="w-full opacity-100"
        :style="[passwordExpiredCustomParamsFields.styles.form.buttons.bgColor]"
        @click="gotoLogin"
        data-vs-button="auth-expired-success-btn-gotologin"
      >
        {{ $t('message.loginComponent.passwordExpired.success.go_back_btn') }}
      </zt-button>
    </div>
  </div>
</template>

<script>
import GraphicBase from '@/components/commons/Illustrations/graphicBase'
import CircleCheck from '@/components/commons/Illustrations/graphicSVG/circleCheck'
export default {
  name: 'ztAuthResetPassSuccess',
  components: { CircleCheck, GraphicBase },
  props: {
    passwordExpiredCustomParamsFields: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    gotoLogin() {
      this.$router.replace({ name: 'login' })
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .zt-button {
  height: 3.25rem;
}

.success-message {
  color: #0081c6;
}
</style>
